export const hasPermission = (role = "", requiredRoles = []) => {
  if (typeof role !== "string") {
    return false;
  }

  return requiredRoles.includes(role);
};
